<div class="header align-items-center">
    <p>Realizar inversión</p>
    <button class="close-container cr-pointer d-flex justify-content-center btn"
      (click)="close()" tabindex="0" aria-label="Cerrar">
      <fa-icon [icon]="iconClose" class="fs-24 cl-light-grey"></fa-icon>
    </button>
</div>
<form [formGroup]="formPurchase" class="body">

    <div class="fs-14 pd-r">
        <div class="mont">
            <div class="d-block d-md-flex align-items-center justify-content-between pt-1 pb-4">
                <p class="m-0 fs-15 text-center text-md-start cl-black">Selecciona el monto a invertir en el proyecto</p>
                <div class="d-md-flex justify-content-end text-center text-md-end mt-4 mt-md-0">
                    <button type="button" class="btn p-0" (click)="editValue(initAmount.value - 1000)" [disabled]="isDisabled">
                        <img class="less-icon" src="/assets/icons/less-icon.svg" alt="">
                    </button>
                    <input
                     type="text"
                     class="remove-input"
                     formControlName="amount"
                     currencyMask
                     [options]="{ precision: 0 }"
                     (ngModelChange)="editInput()"
                     autocomplete="off"
                     name="amount-input"
                     id="amount-input"
                     >
                    <button type="button" class="btn p-0" (click)="editValue(initAmount.value + 1000)" [disabled]="isDisabled">
                        <img class="sum-icon" src="/assets/icons/more-icon.svg" alt="">
                    </button>
                </div>
            </div>
        </div>
        <div class="py-3 slider-st mt-3" *ngIf="!isDisabled">
            <ngx-slider [(value)]="initAmount.value" [options]="options" (valueChange)="editValue($event)"></ngx-slider>
        </div>
    </div>


    <div class="fs-15 pd-r-2">

        <div class="d-flex align-items-center justify-content-between mb-2">
            <p class="m-0 fw-bold">Rendimiento {{ infoProject?.state == 'fixed' ? 'fijo' : 'variable' }} anual: </p>
            <p class="m-0 fw-bold">{{ infoProject?.performance }} %</p>
        </div>

        <div class="d-flex align-items-center justify-content-between my-2">
            <p class="m-0">Participaciones seleccionadas:</p>
            <p class="m-0 fw-bold">{{ initAmount.value / 1000 }}</p>
        </div>

        <div class="d-flex align-items-center justify-content-between my-2">
            <p class="m-0">Precio unitario por participación:</p>
            <p class="m-0 fw-bold">${{ infoProject?.phase?.partValue || 1000 | number }}</p>
        </div>

        <hr>

        <div class="d-flex align-items-center justify-content-between my-3 row">
            <p class="col-12 col-md-9 m-0">Puedes invertir hasta <strong class="cl-primary-card">${{ totalFreePerUser * 1000 | number }}</strong> en el proyecto
               <i class="mnf-explain-border ms-1" matTooltip="Máximo 5% del financiamiento
               Para extender tu límite en todos los proyectos, comunícate con nosotros para acreditarte como 'Inversionista Experimentado'" matTooltipPosition="right"
               *ngIf="!userWithoutPurchaseLimit"></i>
               <i class="mnf-explain-border ms-1" matTooltip="Acreditaste ser un 'Inversionista Experimentado', puedes invertir sin limite en todos los proyectos"
               matTooltipPosition="right" *ngIf="userWithoutPurchaseLimit"></i>
            </p>

            <button
               class="col-12 col-md-3 m-0 fw-bold text-decoration-underline cl-primary-card cr-pointer d-flex justify-content-end mt-3 mt-md-0 btn"
               (click)="showLimitParts = !showLimitParts">
               {{ showLimitParts ? 'Ver menos' : 'Ver más' }}</button>
        </div>
        <div class="animated fadeIn fs-13" *ngIf="showLimitParts">
            <div class="d-flex align-items-center justify-content-between my-2">
                <p class="m-0">Tus participaciones adquiridas en el proyecto:</p>
                <p class="m-0 fw-bold">{{ partsActual | number }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between my-2">
                <p class="m-0 fw-bold">Las participaciones que aún puedes adquirir:</p>
                <p class="m-0 fw-bold">{{ totalFreePerUser | number }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-between my-2">
                <p class="m-0">Límite de participaciones por inversionista:</p>
                <p class="m-0 fw-bold">{{ infoProject?.participationsMaxPerUser | number }}</p>
            </div>
        </div>

    </div>

    <div class="mt-4 d-block d-md-flex align-items-center justify-content-between bg-primary-card p-3" *ngIf="!isDisabled">
        <div class="col-12 col-md-9 purchase-text">
            <p class="mb-1 m-0 fs-14 text-center text-white">¡Al invertir <strong> ${{ initAmount.value | number }}</strong> ganarás en rendimientos <strong>${{ totalPerformance * 10 | number }}</strong>!</p>
            <hr class="m-0 line-white">
            <p class="mt-1 m-0 fs-12 text-center text-white mt-1">{{ getTextByCapitalization(infoProject?.capitalization) }} recibirás {{ repartEstimate * 10 | currency: 'MXN'}} de rendimiento y al finalizar el plazo, recibirás tus {{ initAmount?.value | currency: 'MXN':'symbol':'1.0-0'}} invertidos.  <span *ngIf="infoProject?.soldPerformance">más una utilidad por venta estimada de {{soldTotalPerformance | number }}</span></p>
        </div>
        <div class="col-12 col-md-3 text-center text-md-end mt-3 mt-md-0">
            <button class="btn fs-14 btn-white cl-white fw-sbold" (click)="next()">Invertir</button>
        </div>

    </div>

</form>
